// src/features/history/services/historyService.ts

import api from '../../../api/axios';
import { HISTORY_ENDPOINTS } from '../../../api';

export const historyService = {
  async updateMemo(
    historyId: number,
    memo: string,
  ): Promise<void> {
    await api.patch(
      HISTORY_ENDPOINTS.ADMIN.MEMO(historyId),
      {
        memo,
      },
    );
  },
};